module.exports = __webpack_public_path__ + "static/media/logo_mobile.0300cf8d.png";